<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Educational Trips</h1>
    <p class="lead mb-0 text-orange-light">Enriching Educational Experiences</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-5 align-items-center">
    <div class="col-12 col-lg-8">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-map-location-dot me-2"></i> Our Cultural Heritage Tours
        </h3>
        
        <p class="lead text-muted mb-0" style="line-height: 1.8; text-align: justify;">
          Welcome to our educational tours, where learning goes beyond the confines of the classroom and students embark on a journey through time and culture. Our thoughtfully curated heritage tours offer a unique blend of education, exploration, and enjoyment.
        </p>
      </div>
    </div>

    <!-- Right Side Feature Box -->
    <div class="col-12 col-lg-4">
      <div class="focus-card p-4 shadow-lg rounded-4 text-white d-flex flex-column justify-content-center text-center" style="background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%); min-height: 250px;">
        <h4 class="fw-bold mb-3"><i class="fa-solid fa-quote-left me-2"></i> Outside the Classroom</h4>
        <p style="line-height: 1.6;">
          Learning goes beyond boundaries through thoughtfully curated heritage exploration.
        </p>
      </div>
    </div>
  </div>

  <h3 class="fw-bold text-success mt-5 mb-4 text-uppercase">
    <i class="fa-solid fa-camera-retro me-2"></i> Tour Gallery
  </h3>

  <div class="row g-4">
    <div class="col-12 col-md-6 col-lg-3" *ngFor="let item of tripImages">
      <div class="trip-card h-100 shadow-sm border-0 rounded-4 overflow-hidden bg-white">
        <div class="trip-img-box position-relative">
          <img [src]="item.img" [alt]="item.title" class="trip-img img-fluid">
          <div class="img-badge bg-orange text-white fw-bold px-2.5 py-1 rounded small">Trip</div>
        </div>
        <div class="p-4 text-center">
          <span class="text-orange d-block small fw-bold mb-1"><i class="fa-solid fa-location-dot me-1"></i> {{ item.location }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
